export default "__VITE_ASSET__D49DOXLg__"